import { DateRangeOption } from '../types/task-operations-types';

/**
 * Build query key based on various parameters
 */
export const getTaskQueryKey = (
  userId: string | undefined,
  dateRange: DateRangeOption,
  dateRangeParams: { startDate: string; endDate: string } | null,
  strictDateRange: boolean = false,
  noDateFilter: boolean = false
) => {
  return dateRangeParams 
    ? ['tasks', userId, dateRange, dateRangeParams.startDate, dateRangeParams.endDate, strictDateRange, noDateFilter]
    : ['tasks', userId, 'all', strictDateRange, noDateFilter];
};
